// Re-export all endpoints as ENDPOINTS object for backward compatibility
import * as allEndpoints from "./endpoints"

export const ACTIONS = require("./actions")
export * from "./endpoints"

export const ENDPOINTS = allEndpoints

// filters
export const FILTER_IN_ALL_FOLDERS_INIT_VALUE = 0
export const FILTER_IN_ALL_FOLDERS = "external"


export const CLOSE_PARAM = "closed"
export const NOT_CLOSED = 1
export const CLOSED = 0
